/**
 * Envía un log de auditoría al backend de MiFirmaLite.
 * Permite INFO, WARN, ERROR y logs manuales.
 * @param {Object} params
 * @param {'INFO'|'WARN'|'ERROR'} params.state - Severidad
 * @param {string} params.message - Mensaje principal
 * @param {string} [params.level='ERROR'] - Alias opcional de severidad (backward)
 * @param {string} [params.event=''] - Evento manual opcional
 * @param {Object} [params.args={}] - Información adicional relevante
 */

const BASE_URL = process.env.REACT_APP_BASE_URL;
const AUDIT_ENABLED = process.env.REACT_APP_AUDIT_LOG_SWITCH !== 'false';

export async function logAudit({
                                   state = 'ERROR',
                                   message,
                                   level, // opcional, alias para state
                                   event = '',
                                   args = {}
                               }) {
    try {
    const user = getCurrentUser();
    const device = JSON.stringify(getDeviceInfo());
    const severity = String(level || state || 'ERROR').toUpperCase();
    const eventData = {
        action: "AUDITORIA_FRONTEND",
        date: new Date().toISOString(),
        state: severity,
        message,
        error: severity === 'ERROR' ? (message || '') : '',
        user,
        portalId: "MiFirmaLite",
        device,
        processId: generateUUID(),
        args:  serializeArgs({
            ...args,
            event, // Si es un log manual, podemos pasar el nombre del evento aquí
            screen: device.screen,
            route: window.location.pathname,
            url: window.location.href,
            timestamp: new Date().toISOString(),
        })
    };

        if (!AUDIT_ENABLED) {
            console.debug('[AUDIT DISABLED]', eventData);
            return;
        }


        try {
        const url = `${BASE_URL}/audit/log`;
        await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(eventData),
            keepalive: true,
        });
    } catch (err) {
        console.error('Error sending audit log:', err);
    }
} catch (err) {
    // Error en la construcción del log, solo mostrar en consola
    console.error('Error in logAudit:', err);
}
}

/**
 * Decodifica y extrae los datos del usuario logueado desde sessionStorage.userinfo
 * Espera un JWT o un objeto en base64 codificado como string
 */
function getCurrentUser() {
    try {
        const userinfoB64 = sessionStorage.getItem('userinfo');
        if (!userinfoB64) return 'usuario anónimo';
        // Decodifica base64
        const json = userinfoB64;
        const userObj = JSON.parse(json);
        // Retorna un string combinando nombre completo y uuid único
        return (
            `${userObj.primer_nombre || ''} ${userObj.segundo_nombre || ''} ${userObj.primer_apellido || ''} ${userObj.segundo_apellido || ''}`.trim() +
            ` [${userObj.uuid || userObj.sub || ''}]`
        );
    } catch {
        return 'usuario anónimo';
    }
}

/**
 * Info extendida del dispositivo y navegador
 */
function getDeviceInfo() {
    return {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            orientation: window.screen.orientation?.type || "unknown",
        },
        vendor: navigator.vendor,
    };
}

function serializeArgs(argsObj) {
    if (!argsObj || typeof argsObj !== 'object') return [];
    return Object.entries(argsObj).map(
        ([key, value]) => {
            let stringValue = (typeof value === 'object') ? JSON.stringify(value) : String(value);
            return `${key}: ${stringValue}`;
        }
    );
}
function generateUUID() {
    // Genera un UUID v4 simple
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
